module.exports = __webpack_public_path__ + "static/media/founder-razmostafavi.6c64ca20.webp";